<template>
    <div class="full-height">
    <crud-layout ref="crudLayout"
        name="teste"
        :interface="nmInterface"
        :id="id"
    >

    </crud-layout>
</div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import RouteDetailingPageSearch from './RouteDetailingPageSearch.vue'
import { repository, messageBox } from 'jtech'
const { CrudLayout } = JtCrud

@Component({
  name: 'RouteDetailing',
  components: { CrudLayout, RouteDetailingPageSearch },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class RouteDetailing extends Vue {
  get pageSearch () {
    return RouteDetailingPageSearch
  }

  get nmInterface () {
    return this.interface
  }

  created () {
    setTimeout(this.pageAdded, 300)
  }

  mounted () {
    this.$refs.crudLayout.onButton('btGenerate', this.onGenerate)
  }

  pageAdded () {
    this.$refs.crudLayout.removePage({
      name: this.$gettext('ROUTE_DETAILING_SEARCH'),
      label: this.$gettext('ROUTE_DETAILING_SEARCH'),
      nmInterface: this.nmInterface,
      component: this.pageSearch,
      flClose: false
    })
    this.$refs.crudLayout.addPage({
      name: this.$gettext('ROUTE_DETAILING_SEARCH'),
      label: this.$gettext('ROUTE_DETAILING_SEARCH'),
      nmInterface: this.nmInterface,
      component: this.pageSearch,
      flClose: false
    })
    this.$refs.crudLayout.setPage('btPesquisar')
  }

  async onGenerate ({ button, params, page, controller }) {
    await repository.create('routeDetailing.gravar', { route: params.id, pathStartDate: params.routeDate })
    this.$refs.crudLayout.setPage(this.$gettext('ROUTE_DETAILING_SEARCH'))
  }
}

export default RouteDetailing
</script>

<style>

</style>
